export const styles = {
  subtitle: {
    fontSize: 13,
    color: '#666',
    marginBottom: 16,
    marginTop: 4,
  },
  actionsBar: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 8,
    paddingLeft: '6px',
  },
  sortableHeader: {
    cursor: 'pointer',
  },
  downloadBtn: {
    padding: 6,
  },
  emptyState: {
    textAlign: 'center',
    color: '#888',
    fontSize: 13,
    padding: '32px 0',
  },
}
